export const activateSidebar = {
    activateSidebar: false,
    lastUpdate: +(new Date())
}